// extracted by mini-css-extract-plugin
export default {"prgrph":"styles_prgrph__YV04r"};